var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTop30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-top30",
    transform: "translate(3.859 2.857)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3065",
    "data-name": "Rectangle 3065",
    width: 40,
    height: 40,
    transform: "translate(-3.859 -2.857)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6766",
    "data-name": "Path 6766",
    d: "M5057.676,16264.066a1.471,1.471,0,0,1-.539-2.841v-.964a3.806,3.806,0,0,1,3.8-3.8h.861v-2.943a9.921,9.921,0,0,1-1.563-1.33c-2.727-.245-5.249-1.919-7.123-4.731a19.5,19.5,0,0,1-2.972-10.7,1.474,1.474,0,0,1,1.47-1.473h3.2c0-.229,0-.453,0-.674a1.469,1.469,0,0,1,1.469-1.47h18.654a1.472,1.472,0,0,1,1.474,1.47c0,.221,0,.445-.008.674h3.2a1.472,1.472,0,0,1,1.469,1.473,19.467,19.467,0,0,1-2.972,10.7c-1.874,2.813-4.4,4.486-7.123,4.731a9.94,9.94,0,0,1-1.563,1.33v2.943h.861a3.806,3.806,0,0,1,3.8,3.8v.964a1.471,1.471,0,0,1-.535,2.841Zm2.4-3.8v.861h11.049v-.861a.864.864,0,0,0-.861-.861h-9.331A.861.861,0,0,0,5060.08,16260.262Zm4.662-3.8h1.722v-1.784a6.057,6.057,0,0,1-1.722,0Zm-4.417-9.314a13.025,13.025,0,0,0,1.641,2.567,1.348,1.348,0,0,1,.139.163,6.364,6.364,0,0,0,1.759,1.457,1.148,1.148,0,0,1,.139.069,3.465,3.465,0,0,0,3.2,0,.919.919,0,0,1,.139-.069,6.422,6.422,0,0,0,1.755-1.457,1.852,1.852,0,0,1,.143-.163,13.3,13.3,0,0,0,1.641-2.567,27.912,27.912,0,0,0,2.547-11.062h-15.658A27.856,27.856,0,0,0,5060.325,16247.147Zm13.445.788a9.51,9.51,0,0,0,1.874-2.106,16.009,16.009,0,0,0,2.424-7.6h-1.836A29.8,29.8,0,0,1,5073.771,16247.936Zm-18.208-2.106a9.5,9.5,0,0,0,1.877,2.106,29.785,29.785,0,0,1-2.465-9.707h-1.837A16,16,0,0,0,5055.562,16245.829Z",
    transform: "translate(-5049.461 -16231.461)",
    fill: "#171c28"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop30);
export default __webpack_public_path__ + "static/media/icon-top30.16a4aa43.svg";
export { ForwardRef as ReactComponent };